export default "__VITE_ASSET__f3ca386c__"